<template>
    <header class="mb-50 sm-mb-20">
        <div class="header-wrapper">
            <div class="container">
                <div class="header-icons">
                    <a href="https://www.facebook.com/p/IATSE-National-Benefit-Funds-100063462075974/" target="_blank"><i class='iatse-icon-facebook'></i></a>
                </div>
                <div class="header-contact">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.69175 1.54395L5.12442 2.31924C5.51489 3.01889 5.35814 3.93672 4.74316 4.5517C4.74316 4.5517 4.74316 4.5517 4.74316 4.55171C4.74304 4.55182 3.99731 5.29777 5.3497 6.65016C6.70143 8.0019 7.44734 7.25751 7.44815 7.2567C7.44818 7.25667 7.44816 7.25669 7.44819 7.25666C8.06317 6.64171 8.98098 6.48497 9.68062 6.87543L10.4559 7.30811C11.5124 7.89772 11.6372 9.37933 10.7085 10.308C10.1505 10.866 9.46695 11.3002 8.7113 11.3288C7.4392 11.377 5.27887 11.0551 3.11182 8.88803C0.944772 6.72098 0.62283 4.56065 0.671055 3.28856C0.699702 2.5329 1.13389 1.84933 1.69189 1.29132C2.62052 0.362692 4.10214 0.487462 4.69175 1.54395Z" fill="#FCFCFC"/>
                    </svg>
                    <small>Toll Free 800-456 Fund (3863)</small>
                </div>
            </div>
        </div>
        <div class="header-search-wrapper container">
            <div class="logo-wrapper">
                <a :href="baseUrl" class="header-action">
                    <figure>
                        <img :src="`${baseUrl}/storage/app/media/logo.png`" alt="Logo" title="IATSE Benefits Fund Logo" width="230"/>
                    </figure>
                    <div class="spotlight"></div>
                </a>
            </div>
            <div class="wrapper">
                <form class="w-25"></form>

                <div class="header-actions-wrapper">
                    <div class="header-actions">
                        <router-link :to="{ name: 'register' }" class="header-action">
                            <i class='iatse-icon-user-rounded'></i>
                            <div class='text hide-mobile'> Register </div>
                        </router-link>
                        <div class="divider"></div>
                        <router-link :to="{ name: 'login' }" class="header-action">
                            <i class='iatse-icon-login'></i>
                            <div class='text hide-mobile'> Login </div>
                        </router-link>
                    </div>
                    <a :href="`${baseUrl}/forgot-credentials`" class="header-action">
                        <div class='text-underline'> Forgot Credentials </div>
                    </a>
                </div>
            </div>
        </div>
    </header>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    setup() {
        return {
            baseUrl: process.env.VUE_APP_PUBLIC_URL
        }
    }
 })
</script>


<style lang="scss" scoped>
    body {
        background: #F6F8FF;
    }

    header {
        position: relative;

        a {
            text-decoration: none;
            color: #1e1e1e;
        }

        .text-underline {
            font-size: 16px;
            color: #1e1e1e;
        }

        .header-wrapper {
            height: 40px;
            background-color: #17388C;
            color: #FCFCFC;

            @media (max-width: 768px) {
                display: none;
            }

            .container {
                display: flex;
                align-items: center;
                justify-content: space-between;
                height: 100%;

                .header-icons {
                    display: flex;
                    gap: 10px;

                    .icon-menu::before {
                        font-size: 24px;
                    }
                }

                .header-contact {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    gap: 10px;
                }
            }
        }

    .header-search-wrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: 20px;
        position: inherit;

        @media (max-width: 768px) {
            background: white;
            padding-top: 5px;
        }

        .logo-wrapper {
            position: relative;
            width: 50%;
            height: 100%;
            z-index: 1;

            img {
                max-width: 190px;

                @media (max-width: 768px) {
                    max-width: 110px;
                }
            }

            .spotlight {
                position: absolute;
                width: 383.07px;
                background: linear-gradient(180deg, rgba(255, 242, 0, 0.6) 1.78%, rgba(250, 228, 82, 0.12) 104%);
                height: 800%;
                top: 246%;
                left: 58%;
                width: 45%;
                transform: translate(-50%, -50%) rotate(305deg);
                pointer-events: none;
                clip-path: polygon(50% 0%, 100% 100%, 0% 100%);
                z-index: -1;
                opacity: 40%;

                @media (max-width: 768px) {
                    top: 180%;
                    left: 87%;
                    width: 70%;
                    height: 500%;
                }
            }

            .fade {
                animation: fadeIn 3s;
            }

            @keyframes fadeIn {
                0% { opacity: 0; }
                100% { opacity: 0.4; }
            }
        }

        .wrapper {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 20px;
            width: 100%;

            .header-actions-wrapper {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: space-between;
                width: 100%;

                @media (max-width: 768px) {
                    align-items: flex-end;
                    padding-right: 10px;
                }

                a {
                    i::before {
                        font-size: 24px;
                        color: rgba(23, 56, 140, 1);

                        @media (max-width: 768px) {
                            font-size: 16px;
                        }
                    }

                    .text {
                        @media (max-width: 768px) {
                            display: none;
                        }
                    }

                    .text-underline {
                        text-decoration: underline;

                        @media (max-width: 768px) {
                            display: none;
                        }
                    }
                }

            .header-actions {
                display: flex;
                align-items: flex-start;
                justify-content: space-between;
                gap: 10px;
                width: 100%;
                max-width: 50%;

                @media (max-width: 768px) {
                    align-items: center;
                }

                .header-action {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: space-between;
                    width: 60px;
                    height: 100%;

                    .icon-menu::before {
                        font-size: 24px;
                        cursor: pointer;
                    }

                    .icon-menu::before, .icon-search::before {
                    }
                }

                .divider {
                    margin: 0 15px;
                    // border-left: 2px solid #D8D8D8;
                    height: 30px;
                    width: 1px;
                }

                .mobile-icon {

                    i::before {
                        font-size: 24px;
                    }
                }
            }
        }
    }
}

    }
</style>